<template>
  <VBusHelper
    :actionOnMounted="
      () =>
        $bus.emit($constants.EVENTS.BOOKMAKER.DETAIL.REFRESH, {
          bookmakerId: $attrs.bookmakerId,
          bookmaker: $attrs.bookmaker
        })
    "
  />
  <div
    v-if="
      $stores.bookmaker?.state?.bookmakerData?.[
        `${$attrs?.bookmaker}_${$attrs?.bookmakerId}`
      ]?.error
    "
  >
    <span class="text-red-500 font-bold">Erreur de chargement</span>
  </div>
  <div
    v-else-if="
      $stores.bookmaker?.state?.bookmakerData?.[
        `${$attrs?.bookmaker}_${$attrs?.bookmakerId}`
      ]?.data
    "
    class=""
  >
    <span>
      {{
        $stores.bookmaker?.state?.bookmakerData?.[
          `${$attrs?.bookmaker}_${$attrs?.bookmakerId}`
        ]?.data?.name
      }}
      ({{ $attrs?.bookmakerId }})
    </span>
    <span
      class="underline font-bold"
      v-if="$attrs.canChange"
      @click="
        () => {
          $bus.emit($constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE, {
            bookmakerId: $attrs.bookmakerId,
            bookmaker: $attrs.bookmaker
          });
        }
      "
    >
      Changer
    </span>
  </div>
  <div
    v-else-if="
      $stores.bookmaker?.state?.bookmakerData?.[
        `${$attrs?.bookmaker}_${$attrs?.bookmakerId}`
      ]?.loading
    "
    class="shimmerContainer"
  >
    <span>Recherche..</span>
  </div>
  <div v-else>...</div>
</template>
